'use client';

interface InfoRow {
    key: string;
    value: string;
}

interface InfoCardProps {
    rows: InfoRow[];
}

export default function InfoCard({ rows }: InfoCardProps) {
    return (
        <div className="flex flex-col gap-1.5 rounded-md border-[0.5px] border-line bg-subtle p-2.5 text-xs">
            {rows.map((row, index) => (
                <div key={index} className="flex items-center justify-between gap-2">
                    <span className="text-muted">{row.key}</span>
                    <span className="font-medium text-ink">{row.value}</span>
                </div>
            ))}
        </div>
    );
}
